import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 py-20">
      <div className="container mx-auto px-4 max-w-4xl">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-sky-600 hover:text-sky-700 mb-8 transition-colors"
        >
          <ArrowLeft size={20} />
          Retour à l'accueil
        </button>

        <h1 className="text-4xl font-bold text-slate-900 mb-8">Politique de Confidentialité</h1>

        <div className="bg-white rounded-xl p-8 shadow-sm space-y-6">
          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Collecte des données</h2>
            <p className="text-slate-700 mb-4">
              Le site Garage 1225 Sàrl respecte votre vie privée. Nous ne collectons et ne conservons aucune 
              donnée personnelle directement sur notre site web.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Formulaire de contact</h2>
            <p className="text-slate-700 mb-4">
              Lorsque vous utilisez le formulaire de contact sur notre site, celui-ci ouvre directement votre 
              application de messagerie électronique (email) installée sur votre appareil.
            </p>
            <p className="text-slate-700 mb-4">
              Les informations que vous saisissez dans le formulaire (nom, email, téléphone, message) ne sont 
              pas stockées sur notre site. Elles sont uniquement préremplies dans le brouillon d'email qui 
              s'ouvre sur votre appareil.
            </p>
            <p className="text-slate-700 mb-4">
              Vous gardez le contrôle total : vous pouvez modifier ou annuler l'envoi avant d'envoyer 
              effectivement l'email depuis votre application de messagerie.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Cookies</h2>
            <p className="text-slate-700">
              Ce site utilise uniquement des cookies techniques nécessaires à son fonctionnement. 
              Aucun cookie de tracking ou de publicité n'est utilisé.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Services tiers</h2>
            <p className="text-slate-700 mb-4">
              <strong>Google Maps :</strong> Notre site affiche une carte Google Maps pour faciliter votre localisation. 
              L'utilisation de Google Maps est soumise à la politique de confidentialité de Google.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Vos droits</h2>
            <p className="text-slate-700 mb-4">
              Pour toute question concernant la protection de vos données personnelles, vous pouvez nous contacter :
            </p>
            <div className="bg-slate-50 rounded-lg p-4 space-y-1 text-slate-700">
              <p><strong>Email :</strong> garage1225@bluewin.ch</p>
              <p><strong>Téléphone :</strong> 022 860 07 07</p>
              <p><strong>Adresse :</strong> Rue François-Jacquier 17, 1225 Chêne-Bourg, Suisse</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Mise à jour</h2>
            <p className="text-slate-700">
              Cette politique de confidentialité peut être mise à jour. La version en vigueur est celle publiée 
              sur cette page. Dernière mise à jour : Mars 2025.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
